import { useEffect, useState } from "react";
import api, { formatPrice } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const STATUS = ["pending", "paid", "shipped", "delivered", "cancelled", "refunded"];

export default function OwnerOrders() {
  const [orders, setOrders] = useState(null);
  const refresh = () => api.get("/admin/orders").then(({ data }) => setOrders(data.orders));
  useEffect(() => { refresh(); }, []);
  if (!orders) return <Skeleton className="h-96 bg-white/5" />;

  const update = async (id, patch) => {
    try { await api.post(`/admin/orders/${id}/status`, patch); toast.success("Order updated."); refresh(); }
    catch { toast.error("Could not update."); }
  };

  return (
    <div data-testid="owner-orders">
      <h1 className="font-display text-3xl font-extrabold text-white">Orders</h1>
      {orders.length === 0 ? (
        <div className="mt-6 rounded-xl border border-white/10 bg-white/5 p-10 text-slate-400 text-center">No orders yet.</div>
      ) : (
        <div className="mt-6 space-y-2">
          {orders.map((o) => (
            <div key={o.order_id} className="rounded-lg border border-white/10 bg-white/5 p-4">
              <div className="flex flex-wrap items-center gap-4 justify-between">
                <div>
                  <div className="font-mono text-white">{o.order_id}</div>
                  <div className="text-xs text-slate-400">{o.email} · {new Date(o.created_at).toLocaleString()}</div>
                  <div className="text-xs text-slate-500 mt-1">{o.items?.length || 0} items · {formatPrice(o.total)}</div>
                </div>
                <div className="flex items-center gap-2">
                  <Select value={o.status} onValueChange={(v) => update(o.order_id, { status: v })}>
                    <SelectTrigger className="w-36 bg-white/5 border-white/10 text-white"><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                  <Input placeholder="Tracking #" defaultValue={o.tracking_number || ""} onBlur={(e) => e.target.value !== (o.tracking_number || "") && update(o.order_id, { tracking_number: e.target.value })} className="w-44 bg-white/5 border-white/10 text-white font-mono text-sm" />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
